export enum TextSectionLayoutVariant {
  fullHeight = "fullHeight", 
  square = "square"
}